import { render, staticRenderFns } from "./pickupdone.vue?vue&type=template&id=6dce0012"
import script from "./pickupdone.vue?vue&type=script&lang=js"
export * from "./pickupdone.vue?vue&type=script&lang=js"
import style0 from "./pickupdone.vue?vue&type=style&index=0&id=6dce0012&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports